<template>
  <div>
    <el-upload
      action="#"
      list-type="picture-card"
      :file-list.sync="fileList" 
      :before-upload="beforeAvatarUpload" 
      :on-success="handleSuccess" 
      :http-request="httpRequest" 
      :on-change="handleChange"
      :class="{disabled: fileList && fileList.length == 1}"
    >
      <el-button v-show="false" ref="uploadBtn" size="small" type="primary">上传隐藏</el-button>
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url" alt=""
        >
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            
          >
            <i class="el-icon-zoom-in" @click="handlePictureCardPreview(file)"></i>
          </span>
          <span
            class="el-upload-list__item-delete"
          >
            <i slot="trigger" class="el-icon-edit" @click="changeImage(file)" v-show="biz_user_id"></i>
          </span>
          <span
            class="el-upload-list__item-delete"
            
          >
            <i class="el-icon-delete" @click="handleRemove(file)" v-show="biz_user_id"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>

</template>

<script>
  import {
    OSSConfig
  } from "@/plugins/common";
  const client = OSSConfig();
  export default {
    data() {
      return {
        uploadUrl: '',
        dialogImageUrl: '',
        file: '',
        hdList: [],
        dialogVisible: false,
        img:'',
        needCFile: {},
        biz_user_id:""
        // currentRow: null,
      };
    },
    props: {
      fileList: Array,
    },
    created() {
      this.biz_user_id = localStorage.getItem("user_id") == "42" ? true : false;
  },
    methods: {
      // 编辑图片
      changeImage(file) {
        console.log('更换图片',file);
        this.$refs.uploadBtn.$el.click()
      },
     
      //上传图片
      httpRequest(option) {
        console.log('上传图片',option);
        let file = option.file;
        const point = file.name.lastIndexOf('.');
        let suffix = file.name.substr(point);
        let date = new Date().getTime();
        let fileNames = `$${parseInt(Math.random() * 10000000000000)}_${date}${suffix}`;
        client.put(fileNames, file).then(res => {
          console.log(res);
          option.onSuccess(res);
        })
        
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG或者PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2M!');
        }
        return isJPG && isLt2M;
      },
      handleRemove(file) {
        console.log('删除图片',file);
        this.$emit('update:fileList', []);
      },
      handlePictureCardPreview(file) {
        console.log('查看图片',file);
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
        let newFileList = []
        newFileList.push(fileList[fileList.length-1])
        this.$emit('update:fileList', newFileList);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .img {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .red {
    color: red;
  }
  .upload-operate {
    position: absolute;
    left: 150px;
    top: 60px;
    width: 60px;
    .el-button+.el-button {
        margin-left: 0;
    }
  }
</style>
<style>
  .disabled .el-upload.el-upload--picture-card {
    display: none !important;
  }

  .disabled .el-button--success.is-plain {
    display: none !important;
  }
</style>